import { jsx as a, jsxs as C } from "react/jsx-runtime";
import { createContext as z, useState as N, useCallback as d, useMemo as k, useContext as A, useEffect as F } from "react";
import { faCheck as B } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as R } from "@fortawesome/react-fontawesome";
import { Button as V } from "../button/Button.js";
import { Separator as $ } from "../separator/Separator.js";
import { twMerge as g } from "tailwind-merge";
const O = z({
  activeStep: 0,
  steps: [],
  isOnFirstStep: !1,
  isOnLastStep: !1,
  goTo: () => {
  },
  goForward: () => {
  },
  goBack: () => {
  },
  registerStep: () => {
  },
  getStepIndex: () => -1,
  toggleStepVisibility: () => {
  }
}), L = ({
  initialStep: c = 0,
  children: r,
  onUpdateStep: t
}) => {
  const [o, h] = N(c), [i, w] = N([]), p = o === 0, u = o === i.length - 1, s = d(
    (e) => {
      if (e < 0 || e >= i.length)
        return;
      const n = i[e];
      if (n.hidden)
        return s(e + 1);
      h(e), t == null || t(n, e);
    },
    [i, t]
  ), v = d(() => {
    u || s(o + 1);
  }, [u, o, s]), S = d(() => {
    p || s(o - 1);
  }, [p, o, s]), y = d(
    (e) => w((n) => [...n, e]),
    []
  ), x = d((e, n) => {
    w((m) => {
      if (e < 0 || e >= m.length)
        return m;
      const b = [...m], I = b[e];
      return I.hidden === n ? m : (b[e] = {
        ...I,
        hidden: n
      }, b);
    });
  }, []), l = d(
    (e) => i.findIndex((n) => n.value === e),
    [i]
  ), f = k(
    () => ({
      activeStep: o,
      steps: i,
      isOnFirstStep: p,
      isOnLastStep: u,
      goTo: s,
      goBack: S,
      goForward: v,
      registerStep: y,
      getStepIndex: l,
      toggleStepVisibility: x
    }),
    [
      o,
      i,
      p,
      u,
      s,
      S,
      v,
      y,
      l,
      x
    ]
  );
  return /* @__PURE__ */ a(O.Provider, { value: f, children: r });
}, M = ({ className: c, children: r, ...t }) => /* @__PURE__ */ a("div", { className: g("flex items-center justify-between", c), ...t, children: r }), Q = ({
  className: c,
  hidden: r = !1,
  value: t,
  onClick: o,
  meta: h,
  children: i,
  ...w
}) => {
  const [p, u] = N(!1), { activeStep: s, goTo: v, registerStep: S, getStepIndex: y, toggleStepVisibility: x } = A(O), l = y(t), f = s === l, e = l < s, n = l > s, m = e ? "Completed step" : "Pending step";
  return F(() => {
    x(l, r);
  }, [r, l, x]), F(() => {
    p || (S({ value: t, meta: h, hidden: r }), u(!0));
  }, [p, r, h, S, t]), r ? null : /* @__PURE__ */ C(
    V,
    {
      variant: "none",
      color: "neutral",
      "aria-current": f ? "step" : void 0,
      "aria-label": `${t} - ${f ? "Current step" : m}`,
      className: g("group w-full last-of-type:w-fit", c),
      onClick: (b) => {
        v(l), o == null || o(b);
      },
      ...w,
      children: [
        /* @__PURE__ */ C(
          "div",
          {
            className: g(
              "relative flex size-6 shrink-0 items-center justify-center rounded-full border-2 border-gray-300",
              f && "border-blue-500",
              e && "border-blue-500 bg-blue-500"
            ),
            children: [
              f && /* @__PURE__ */ a(T, {}),
              e && /* @__PURE__ */ a(R, { size: "xs", className: "text-white", icon: B }),
              /* @__PURE__ */ a(P, { className: g(n && "text-gray-500"), children: i ?? /* @__PURE__ */ a("span", { className: "capitalize", children: t }) })
            ]
          }
        ),
        /* @__PURE__ */ a(
          j,
          {
            className: g("group-last-of-type:hidden", e && "bg-blue-500")
          }
        )
      ]
    }
  );
}, P = ({ className: c, children: r, ...t }) => /* @__PURE__ */ a(
  "p",
  {
    className: g(
      "absolute -bottom-5 whitespace-nowrap text-xs font-medium leading-none lg:text-sm",
      c
    ),
    ...t,
    children: r
  }
), T = () => /* @__PURE__ */ a("div", { className: "h-2.5 w-2.5 shrink-0 rounded-full bg-blue-500" }), j = ({ className: c, ...r }) => /* @__PURE__ */ a(
  $,
  {
    className: g("radix-orientation-horizontal:h-0.5 bg-gray-300", c),
    ...r
  }
), W = L, X = M, Y = j, Z = P, _ = T;
export {
  X as Container,
  _ as Indicator,
  W as Root,
  Y as Separator,
  Q as Step,
  M as Stepper,
  O as StepperContext,
  T as StepperIndicator,
  L as StepperProvider,
  j as StepperSeparator,
  P as StepperText,
  Z as Text
};
